import PersonOutlineIcon from '@material-ui/icons/PersonOutline';
import LabelOutlinedIcon from '@material-ui/icons/LabelOutlined';
import CategoryOutlinedIcon from '@material-ui/icons/CategoryOutlined';
import PhotoCameraOutlinedIcon from '@material-ui/icons/PhotoCameraOutlined';
import LocalOfferOutlinedIcon from '@material-ui/icons/LocalOfferOutlined';
import ColorizeIcon from '@material-ui/icons/Colorize';
import AssignmentIndOutlinedIcon from '@material-ui/icons/AssignmentIndOutlined';
import HomeOutlinedIcon from '@material-ui/icons/HomeOutlined';
import ContactPhoneOutlinedIcon from '@material-ui/icons/ContactPhoneOutlined';
import PeopleOutlineIcon from '@material-ui/icons/PeopleOutline';
import WorkOutlineIcon from '@material-ui/icons/WorkOutline';
import DirectionsCarOutlinedIcon from '@material-ui/icons/DirectionsCarOutlined';
import DeviceHubOutlinedIcon from '@material-ui/icons/DeviceHubOutlined';
import AttachFileIcon from '@material-ui/icons/AttachFile';
import DescriptionOutlinedIcon from '@material-ui/icons/DescriptionOutlined';
import HistoryIcon from '@material-ui/icons/History';
import NotificationsOutlinedIcon from '@material-ui/icons/NotificationsOutlined';
import PersonDetailsForm from 'features/user/components/add-edit-person/PersonDetailsForm';
import PersonNamesTab from 'features/user/components/add-edit-person/PersonNamesTab';
import PersonFeaturesTab from 'features/user/components/add-edit-person/PersonFeaturesTab';
import PersonPhotoTab from 'features/user/components/add-edit-person/PersonPhotoTab';
import PersonSmtRecordsTab from 'features/user/components/add-edit-person/PersonSmtRecordsTab';
import PersonDnaSamplesTab from 'features/user/components/add-edit-person/PersonDnaSamplesTab';
import PersonCredentialsTab from 'features/user/components/add-edit-person/PersonCredentialsTab';
import PersonContactMethodsTab from 'features/user/components/add-edit-person/PersonContactMethodsTab';
import PersonAssociatesTab from 'features/user/components/add-edit-person/PersonAssociatesTab';
import PersonEmploymentTab from 'features/user/components/add-edit-person/PersonEmploymentTab';
import PersonVehicleRegistrationsTab from 'features/user/components/add-edit-person/PersonVehicleRegistrationsTab';
import PersonRelatedRecordsTab from 'features/user/components/add-edit-person/PersonRelatedRecordsTab';
import PersonAttachmentsTab from 'features/user/components/add-edit-person/PersonAttachmentsTab';
import PersonSopsTab from 'features/user/components/add-edit-person/PersonSopsTab';
import PersonHistoryTab from 'features/user/components/add-edit-person/PersonHistoryTab';
import PersonAddressesTab from 'features/user/components/add-edit-person/PersonAddressesTab';
import PersonTagsTab from 'features/user/components/add-edit-person/PersonTagsTab';
import PersonBulletinsTab from 'features/user/components/add-edit-person/PersonBulletinsTab';

import { PersonMenuItemKey } from './personMenuItemKeys';

export const GRID_MENU_KEYS = new Set([
  PersonMenuItemKey.NAMES,
  PersonMenuItemKey.ADDRESSES,
  PersonMenuItemKey.FEATURES,
  PersonMenuItemKey.DNA_SAMPLES,
  PersonMenuItemKey.CREDENTIAL,
  PersonMenuItemKey.CONTACT_METHODS,
  PersonMenuItemKey.ASSOCIATE,
  PersonMenuItemKey.EMPLOYMENT,
  PersonMenuItemKey.VEHICLE_REGISTRATIONS,
  PersonMenuItemKey.ATTACHMENTS,
  PersonMenuItemKey.SOPS,
  PersonMenuItemKey.TAGS,
  PersonMenuItemKey.BULLETINS,
]);

export const PersonSideBarMenuItem = [
  {
    key: 'overview',
    label: 'Overview',
    items: [
      {
        key: PersonMenuItemKey.PERSON_DETAILS,
        label: 'Person Details',
        icon: PersonOutlineIcon,
        content: PersonDetailsForm,
      },
      {
        key: PersonMenuItemKey.NAMES,
        label: 'Names',
        icon: LabelOutlinedIcon,
        content: PersonNamesTab,
      },
    ],
  },
  {
    key: 'identity-bio',
    label: 'Identity & Bio',
    items: [
      {
        key: PersonMenuItemKey.FEATURES,
        label: 'Features',
        icon: CategoryOutlinedIcon,
        content: PersonFeaturesTab,
      },
      {
        key: PersonMenuItemKey.PHOTO,
        label: 'Photo',
        icon: PhotoCameraOutlinedIcon,
        content: PersonPhotoTab,
      },
      {
        key: PersonMenuItemKey.SMT_RECORDS,
        label: 'SMT Records',
        icon: LocalOfferOutlinedIcon,
        content: PersonSmtRecordsTab,
      },
      {
        key: PersonMenuItemKey.DNA_SAMPLES,
        label: 'DNA Samples',
        icon: ColorizeIcon,
        content: PersonDnaSamplesTab,
      },
      {
        key: PersonMenuItemKey.CREDENTIAL,
        label: 'Credential',
        icon: AssignmentIndOutlinedIcon,
        content: PersonCredentialsTab,
      },
    ],
  },
  {
    key: 'contacts-network',
    label: 'Contacts & Network',
    items: [
      {
        key: PersonMenuItemKey.ADDRESSES,
        label: 'Addresses',
        icon: HomeOutlinedIcon,
        content: PersonAddressesTab,
      },
      {
        key: PersonMenuItemKey.CONTACT_METHODS,
        label: 'Contact Methods',
        icon: ContactPhoneOutlinedIcon,
        content: PersonContactMethodsTab,
      },
      {
        key: PersonMenuItemKey.ASSOCIATE,
        label: 'Associate',
        icon: PeopleOutlineIcon,
        content: PersonAssociatesTab,
      },
      {
        key: PersonMenuItemKey.EMPLOYMENT,
        label: 'Employment',
        icon: WorkOutlineIcon,
        content: PersonEmploymentTab,
      },
      {
        key: PersonMenuItemKey.VEHICLE_REGISTRATIONS,
        label: 'Vehicle Reg',
        icon: DirectionsCarOutlinedIcon,
        content: PersonVehicleRegistrationsTab,
      },
    ],
  },
  {
    key: 'records',
    label: 'Records',
    items: [
      {
        key: PersonMenuItemKey.RELATED_RECORDS,
        label: 'Related Records',
        icon: DeviceHubOutlinedIcon,
        content: PersonRelatedRecordsTab,
      },
      {
        key: PersonMenuItemKey.ATTACHMENTS,
        label: 'Attachments',
        icon: AttachFileIcon,
        content: PersonAttachmentsTab,
      },
      {
        key: PersonMenuItemKey.SOPS,
        label: 'SOPS',
        icon: DescriptionOutlinedIcon,
        content: PersonSopsTab,
      },
      {
        key: PersonMenuItemKey.TAGS,
        label: 'Tags',
        icon: LocalOfferOutlinedIcon,
        content: PersonTagsTab,
      },
      {
        key: PersonMenuItemKey.BULLETINS,
        label: 'Bulletins',
        icon: NotificationsOutlinedIcon,
        content: PersonBulletinsTab,
      },
      {
        key: PersonMenuItemKey.HISTORY,
        label: 'History',
        icon: HistoryIcon,
        content: PersonHistoryTab,
      },
    ],
  },
];

export const getSelectedPersonMenu = (key) =>
  PersonSideBarMenuItem.flatMap((group) => group.items).find((item) => item.key === key) || null;
